module.exports = __webpack_public_path__ + "img/turntable.09ec9732.png";